import React from 'react';
import Title from 'lib/src/components/typography/Title';
import Description from 'lib/src/components/typography/Description';
import ChallengeTagsTable from '../ChallengeTagsTable';
import { useParams } from 'react-router';
import DeleteTagModal from '../DeleteTagModal';
import EditTagModal from '../EditTagModal';
import { tagTypes } from 'lib/src/shared/enums/tagTypes';
import CreateTagModal from '../CreateTagModal';
import CreateHeader from '@components/layout/createHeader/CreateHeader';
import LinkButton from '@components/button/LinkButton';
import { getTagRouteEndpoint } from '../utils';

const ChallengeIXProgramme: React.FC = () => {
    const { id, action } = useParams<ParamTypes>();
    return (
        <>
            <CreateHeader>
                <Title>Challenge IX Program</Title>
                <LinkButton
                    color="green"
                    icon="plus"
                    href={`/${getTagRouteEndpoint(tagTypes.tag)}/create`}
                >
                    Create
                </LinkButton>
            </CreateHeader>
            <Description>
                Here is the list of challenge tags currently in the system. To share a tag with a
                user in a URL, replace all spaces with dashes i.e. 'challenge name' with
                'challenge-name'.
            </Description>
            <ChallengeTagsTable type={tagTypes.tag} />
            {action === 'delete' && <DeleteTagModal id={+id} />}
            {action === 'edit' && <EditTagModal id={+id} />}
            {action === 'create' && <CreateTagModal type={tagTypes.tag} />}
        </>
    );
};
interface ParamTypes {
    id: string;
    action: string;
}

export default ChallengeIXProgramme;
